import { api } from './api'

export const getMfaFactors = async () => {
  const { data } = await api.get('/profile/security/identity/mfa')
  return data
}

export const enrollMfaFactor = async ({ factorType, phoneNumber }) => {
  const body = { factorType }
  if (phoneNumber) {
    body.phoneNumber = phoneNumber
  }
  const { data } = await api.post('/profile/security/identity/mfa/enroll', body)
  return data
}

export const activateMfaFactor = async (factorId, oneTimeCode) => {
  const { data } = await api.post(`/profile/security/identity/mfa/${factorId}/activate`, { oneTimeCode })
  return data
}

export const removeMfaFactor = async (factorId) => {
  await api.delete(`/profile/security/identity/mfa/${factorId}`)
}
